<template>
  <Page class="HomePage">
    <BackgroundCarousel
      :images="backgroundSliderImages"
    />

    <div class="container">
      <h1 class="HomePage__heroHeading">
        {{ $t('homepageHeading') }}
      </h1>
      <h3 class="HomePage__heroSubheading">
        {{ $t('homepageSubheading') }}
      </h3>
      <DealFilterInitial />
    </div>
  </Page>
</template>

<script>
// Components
import Page from '@/components/Page.vue';
import BackgroundCarousel from '@/components/BackgroundCarousel.vue';
import DealFilterInitial from '@/components/dealFilter/Initial.vue';
// Images
import vjetrenjaca1 from '@/assets/img/windmills/vjetrenjaca-1.jpg';
import vjetrenjaca2 from '@/assets/img/windmills/vjetrenjaca-2.jpg';
import vjetrenjaca3 from '@/assets/img/windmills/vjetrenjaca-3.jpg';
import vjetrenjaca4 from '@/assets/img/windmills/vjetrenjaca-4.jpg';

export default {
  name: 'HomePage',
  components: {
    Page,
    BackgroundCarousel,
    DealFilterInitial,
  },
  data() {
    return {
      backgroundSliderImages: [
        vjetrenjaca1,
        vjetrenjaca2,
        vjetrenjaca3,
        vjetrenjaca4,
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.HomePage {
  display: flex;
  flex-direction: column;
  position: relative;
}
.HomePage > .container {
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.HomePage__heroHeading {
  @include roboto500;
  color: $color--primary;
  margin-bottom: 0;
}
.HomePage__heroSubheading {
  color: #fff;
}
.DealFilterInitial {
  margin-top: 15px;
}
</style>
